// Загрузка движка в WebAssembly: в браузере — по URL рядом с модулем, в тестах (Node) — из файла.
import init, { initSync, ZoneLookup, engineVersion, principleStatuses, rulesVersion } from "../pkg/tactics_wasm.js";

export { ZoneLookup, engineVersion, principleStatuses, rulesVersion };

let ready: Promise<void> | null = null;

/** Инициализировать модуль один раз. */
export function loadEngine(): Promise<void> {
  if (!ready) {
    ready = (async () => {
      if (typeof window === "undefined" && typeof process !== "undefined") {
        const { readFile } = await import("node:fs/promises");
        const bytes = await readFile(new URL("../pkg/tactics_wasm_bg.wasm", import.meta.url));
        initSync({ module: bytes });
      } else {
        await init();
      }
    })();
  }
  return ready;
}

/** Оценка ячейки сетки. */
export const CELL = { bad: 0, ok: 1, great: 2, exclusion: 3 } as const;
